import { ObjectTypes } from '../api/object'
import { RelatedTableLayout } from '../layouts/types'
import { ObjectsWithConfig } from '../objects/objects'

type RelatedTableProps = {
	layout: RelatedTableLayout
	parent: ObjectTypes[keyof ObjectTypes]
}

export function RelatedTable({ parent, layout }: RelatedTableProps) {
	const related = Object.fromEntries(
		Object.entries(layout.join).map(([key, value]) => [key, parent[value]]),
	)

	return <ObjectsWithConfig object={layout.object} name={layout.name} related={related} />
}
